import { render, staticRenderFns } from "./packstatistical-list.vue?vue&type=template&id=142ef0d4&scoped=true&"
import script from "./packstatistical-list.vue?vue&type=script&lang=ts&"
export * from "./packstatistical-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142ef0d4",
  null
  
)

export default component.exports